import { render, staticRenderFns } from "./image-upload.vue?vue&type=template&id=4c29c59d&scoped=true"
import script from "./image-upload.vue?vue&type=script&lang=js"
export * from "./image-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c29c59d",
  null
  
)

export default component.exports